import moment from 'moment-timezone'

export const padHHMMSSNumber = (n: number): string => {
    return (n < 10 ? '0' : '') + n
}

export const secondsToSmartHHMMSS = (totalSeconds: number | null): string => {
    if (totalSeconds === null) return null
    const duration = moment.duration(totalSeconds, 'seconds')
    const hours = duration.hours()
    const minutes = duration.minutes()
    const seconds = duration.seconds()

    if (hours) {
        return `${hours}:${padHHMMSSNumber(minutes)}:${padHHMMSSNumber(seconds)}`
    } else {
        return `${minutes}:${padHHMMSSNumber(seconds)}`
    }
}

export const formattedDateMMDDYYYY = (dateString, separator = '/') => {
    let date = moment.utc(dateString)
    try {
        if (isNaN(date.year())) {
            date = moment.utc(dateString.substring(0, 15))
        }
    } catch (error) {}

    const year = date.year()
    const month = (1 + date.month()).toString().padStart(2, '0')
    const day = date.date().toString().padStart(2, '0')

    return `${month}${separator}${day}${separator}${year}`
}
export const formattedDateYYYYMMDD = (dateString, separator = '/') => {
    const date = moment.utc(dateString)
    const year = date.year()
    const month = (1 + date.month()).toString().padStart(2, '0')
    const day = date.date().toString().padStart(2, '0')

    return `${year}${separator}${month}${separator}${day}`
}

export const isOfAge = (dateString) => {
    const age = getAge(dateString)
    return (age >= 18 && age < 100) || 'common:invalid_dob_under_18_over_100'
}

export const maximum100YearsOfAge = (dateString) => {
    const age = getAge(dateString)
    return age < 100 || 'common:invalid_dob_over_100'
}

export const getAge = (dateString: string) => {
    return moment().diff(moment(dateString), 'years')
}
